import { render } from "./WinTransfer.vue?vue&type=template&id=631e8433&scoped=true"
import script from "./WinTransfer.vue?vue&type=script&lang=js"
export * from "./WinTransfer.vue?vue&type=script&lang=js"

import "./WinTransfer.vue?vue&type=style&index=0&id=631e8433&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631e8433"]])

export default __exports__